import React, { useEffect } from 'react';
import {
  Box,
  FlexControlledForm,
  Inscription,
  useDebounceState,
  WarningCard,
  WarningIcon,
} from '@common-fe/common-fe';

import { useSubmitFormStore } from '../../stores';

import { GracePeriodPayload, useStore } from './stores/useGracePeriod.store';
import { useGracePeriodFields } from './hooks';

interface Props {
  isEditMode?: boolean;
  onDirty?: (isDirty: boolean) => void;
  isTemplateMode?: boolean;
  isRunoutPassed?: boolean;
}
const GracePeriod: React.FC<Props> = ({ isEditMode, onDirty, isTemplateMode, isRunoutPassed }) => {
  const activateValidate = useSubmitFormStore((state) => state.activateValidate);
  const saveValidate = useSubmitFormStore((state) => state.saveValidate);

  const fields = useGracePeriodFields(false, isTemplateMode, isEditMode);
  const handleSetState = useStore((state) => state.setState);
  const showErrors = useStore((state) => state.showErrors);

  const { setValues, values } = useDebounceState<Partial<GracePeriodPayload>>();
  useEffect(() => {
    if (values) {
      handleSetState(values);
    }
  }, [handleSetState, values]);
  if (!fields.length) {
    return null;
  }
  return (
    <Box background="canvas" round="container1Round">
      <FlexControlledForm
        fields={fields}
        testId="plan_coverage"
        subTitle={
          isRunoutPassed ? (
            <Box margin={{ bottom: 'spacing16' }}>
              <WarningCard
                testId="coverage_runout_warning"
                borderColor="warningBorder"
                icon={<WarningIcon />}
                containerProps={{ pad: { vertical: 'spacing16', horizontal: 'spacing24' } }}
                title={
                  <Inscription color="textBody" lineHeight="20px">
                    The runout period for this plan has already ended. You can no longer modify configurations
                    in this section.
                  </Inscription>
                }
              />
            </Box>
          ) : undefined
        }
        showError={showErrors || activateValidate || saveValidate}
        editMode={isEditMode}
        onChangeValues={setValues}
        onDirty={onDirty}
        // isDisabledMode
        isThinMode
      />
    </Box>
  );
};
export default GracePeriod;
